import { createFileRoute } from '@tanstack/react-router';
import { VaultPage } from '../components/pages/VaultPage/VaultPage';

export const Route = createFileRoute('/account/vaults_/$vaultId')({
  component: VaultPage,
});
